import { render, staticRenderFns } from "./accPurchBadge.vue?vue&type=template&id=6160d885&"
import script from "./accPurchBadge.vue?vue&type=script&lang=js&"
export * from "./accPurchBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6160d885')) {
      api.createRecord('6160d885', component.options)
    } else {
      api.reload('6160d885', component.options)
    }
    module.hot.accept("./accPurchBadge.vue?vue&type=template&id=6160d885&", function () {
      api.rerender('6160d885', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/accPurchBadge.vue"
export default component.exports